// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vYJk","colBig":"styles_colBig__2ngmw","colSmall":"styles_colSmall__1QGSY"};